<template>
    <div>
        <div class="breadcrumbs overlay">
            <div class="container">
                <div class="row align-items-center">
                    <div class="col-lg-8 offset-lg-2 col-md-12 col-12">
                        <div class="breadcrumbs-content">
                            <h1 class="page-title">Research Commercialization</h1>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <div class="about-details detail-section">
            <div class="container">
                <div class="row">

                    <div class="col-12">
                        <div class="details-content">
                            <div class="text">
                                <div class="detail-section mt-4 wow fadeInUp" data-wow-delay=".2s">
                                    <p>
                                        A good percentage of research works in Africa does not get commercialized and
                                        our solution to this is to :
                                    </p>
                                    <ul class="list">
                                        <li>
                                            Connect research works to established companies or startups that can
                                            commercialize them.
                                        </li>
                                        <li>
                                            Adapt existing patents, build products out of them and funds.
                                        </li>
                                        <li>
                                            Build talents, teams and resources around research works
                                        </li>
                                        <li>
                                            create or find and establish a hungry market for these innovations, and
                                            present them to investors for funding.
                                        </li>
                                    </ul>
                                    <p>
                                        Got a research to commercialize?
                                    </p>
                                    <div class="button my-5" style="text-align: center;">
                                        <a href="https://app.tribinnovafrica.com/register?type=research" target="_blank"
                                            class="btn">Click Here <i class="lni lni-arrow-right"></i></a>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    export default {
        name: 'ResearchCommercialization',
        metaInfo: {
            title: "Tribinnov Africa - Research Commercialization",
            meta: [
                { name: "keywords", content: "investment, finance, tribinnov, tribinnov africa, tribe of innovation, tribe, africa, nigeria, funding, crowdfunding, fundraiser" }
            ]
        }
    }
</script>